import { HStack, VStack } from "@gluestack-ui/themed";
import { ValueInfoSectionProps } from "./types";
import Spinner from "@repo/core/components/core/Spinner";
import { Text } from "@repo/core/components/core/Text";
import { PaymentTypeEnum } from "@repo/core/enums/payments";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import {
  getDealMinValue,
  getInvoiceMaxValue,
  getInvoiceMinValue
} from "@repo/core/screens/InvoicePayment/InvoicePayment/utils";

export const ValueInfoSection = ({
  isLoading,
  paymentType,
  invoiceInfo,
  dealInfo
}: ValueInfoSectionProps) => {
  const invoiceMinValue = getInvoiceMinValue(invoiceInfo);
  const invoiceMaxValue = getInvoiceMaxValue(invoiceInfo);
  const dealMinValue = getDealMinValue(dealInfo);
  const renderInvoiceInfo = () => {
    if (invoiceInfo?.dblValor && invoiceInfo?.dblValorMinimo) {
      return (
        <VStack py="$2" px="$3" borderRadius="$lg" bg="$primary0">
          <VStack gap={4}>
            <HStack justifyContent="space-between" alignItems="center">
              <Text fontWeight={500} fontSize="$sm">
                Fatura fechada
              </Text>
              <Text fontWeight={600} fontSize="$sm">
                R$ {invoiceMaxValue}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" alignItems="center">
              <Text fontSize="$xs">Pagamento minimo</Text>
              <Text fontWeight={500} fontSize="$xs">
                R$ {invoiceMinValue}
              </Text>
            </HStack>
          </VStack>
        </VStack>
      );
    } else if (invoiceInfo) {
      return (
        <VStack py="$2" px="$3" borderRadius="$lg" bg="$error50">
          <Text>Esse cartão não possui faturas a serem pagas no momento.</Text>
        </VStack>
      );
    }

    return null;
  };

  const renderDealInfo = () => {
    if (dealInfo?.dblValorEntrada) {
      return (
        <VStack py="$2" px="$3" borderRadius="$lg" bg="$primary0">
          <VStack gap={4}>
            <HStack justifyContent="space-between" alignItems="center">
              <Text fontWeight={500} fontSize="$sm">
                Acordo
              </Text>
              <Text fontWeight={600} fontSize="$sm">
                {numberToBrl(dealMinValue || 0)}
              </Text>
            </HStack>
          </VStack>
        </VStack>
      );
    } else if (dealInfo) {
      return (
        <VStack py="$2" px="$3" borderRadius="$lg" bg="$error50">
          <Text>Esse cartão não possui acordo a ser pago no momento!</Text>
        </VStack>
      );
    }
    return null;
  };

  if (isLoading)
    return (
      <VStack alignItems="center" gap={8}>
        <Spinner size={20} />
        <Text>
          Carregando dados{" "}
          {paymentType === PaymentTypeEnum.INVOICE ? "da fatura" : "do acordo"}
        </Text>
      </VStack>
    );

  if (paymentType === PaymentTypeEnum.INVOICE) {
    return renderInvoiceInfo();
  }

  if (paymentType === PaymentTypeEnum.DEAL) {
    return renderDealInfo();
  }
};
